import React from 'react'
// import styles from './DataCardActions.less'
import { sh, ReduxWrapper, compose, buildPropTypes, pt } from 'common-data/datahelpers'
import { CircleButton } from './CircleButton'
import { FloatGroup } from './FloatGroup'
import _ from 'common-tools/LodashHelper'
import { withMediaQuery } from 'common-tools/ComponentHelper'

export const ContentBoxedDisplayContext = React.createContext(
  {
    loading: false
  }
)

export class DataCardActionsPlain extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  static propTypes = buildPropTypes([
    sh.SessionToken
  ], {
    ListActions: pt.arrayOf(pt.shape({
      toolTip: pt.string,
      helpText: pt.string,
      icon: pt.string,
      color: pt.string,
      onClick: pt.func
    })),
    children: pt.any
  })

  static defaultProps = {
    loading: false
  }

  renderDataCardActions () {
    const { ListActions, SessionAccount, SessionUser } = this.props

    if (_.isArray(ListActions) === false) {
      return null
    }

    if (ListActions.length === 0) {
      return null
    }

    const allowedListActions = _.filter(ListActions, (titleAction) => {
      if (_.isArray(titleAction.permissions)) {
        return SessionAccount.HasPermissions(titleAction.permissions) || SessionUser.HasPermissions(titleAction.permissions)
      } else {
        return true
      }
    })

    if (allowedListActions.length === 1) {
      const singleAction = ListActions[0]
      return <CircleButton placement='bottom' {...singleAction} size='sm' />
    }

    return <FloatGroup margin={35} direction='left' style={{ margin: '0 10px' }}>
      <CircleButton data-tid='openBoxMenu' color='purple' icon='ellipsis-h' size='sm' outline />
      {_.map(allowedListActions, (a, i) => {
        return <CircleButton placement='bottom' key={i} {...a} size='sm' />
      })}
    </FloatGroup>
  }

  render () {
    return (
      <div className='actionsRow'>
        {this.renderDataCardActions()}
      </div>
    )
  }
}

export const DataCardActions = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount,
    sh.SessionUser
  ]),
  withMediaQuery([
    ['isDesktop', { minWidth: 992 }]
  ])
)(DataCardActionsPlain)
